export const VirtualTokenMap = {
  GET_ALL_VIRTUAL_TOKEN_START: "GET_ALL_VIRTUAL_TOKEN_START",
  GET_ALL_VIRTUAL_TOKEN_SUCCESS: "GET_ALL_VIRTUAL_TOKEN_SUCCESS",
  GET_ALL_VIRTUAL_TOKEN_ERROR: "GET_ALL_VIRTUAL_TOKEN_ERROR",
  ADD_VIRTUAL_TOKEN_START: "ADD_VIRTUAL_TOKEN_START",
  ADD_VIRTUAL_TOKEN_SUCCESS: "ADD_VIRTUAL_TOKEN_SUCCESS",
  ADD_VIRTUAL_TOKEN_ERROR: "ADD_VIRTUAL_TOKEN_ERROR",
  SELECT_USER_DETAILS: "SELECT_USER_DETAILS",
  COUNTRY_FILTERS: "COUNTRY_FILTERS",
  APPLY_FILTERS: "APPLY_FILTERS",
  SEARCH_TEXT_CHANGE: "SEARCH_TEXT_CHANGE",
  REFRESH_VIRTUAL_TOKEN_LIST: "REFRESH_VIRTUAL_TOKEN_LIST",
  SET_VIRTUAL_TOKEN_BATCH_NUMBER: "SET_VIRTUAL_TOKEN_BATCH_NUMBER",
  SELECT_VIRTUAL_TOKEN_DETAILS: "SELECT_VIRTUAL_TOKEN_DETAILS",
  GET_ALL_TEMPLATES_START: "GET_ALL_TEMPLATES_START",
  GET_ALL_TEMPLATES_SUCCESS: "GET_ALL_TEMPLATES_SUCCESS",
  GET_ALL_TEMPLATES_ERROR: "GET_ALL_TEMPLATES_ERROR",
  UPDATE_VIRTUAL_TOKEN_START: "UPDATE_VIRTUAL_TOKEN_START",
  UPDATE_VIRTUAL_TOKEN_SUCCESS: "UPDATE_VIRTUAL_TOKEN_SUCCESS",
  UPDATE_VIRTUAL_TOKEN_ERROR: "UPDATE_VIRTUAL_TOKEN_ERROR",
  DELETE_VIRTUAL_TOKEN_START: "DELETE_VIRTUAL_TOKEN_START",
  DELETE_VIRTUAL_TOKEN_SUCCESS: "DELETE_VIRTUAL_TOKEN_SUCCESS",
  DELETE_VIRTUAL_TOKEN_ERROR: "DELETE_VIRTUAL_TOKEN_ERROR",
};

export const VirtualTokenActions = {
  getAllVirtualTokenStart: (data) => ({
    type: VirtualTokenMap.GET_ALL_VIRTUAL_TOKEN_START,
    payload: data,
  }),
  getAllVirtualTokenSuccess: (data) => ({
    type: VirtualTokenMap.GET_ALL_VIRTUAL_TOKEN_SUCCESS,
    payload: data,
  }),
  getAllVirtualTokenError: (errors) => ({
    type: VirtualTokenMap.GET_ALL_VIRTUAL_TOKEN_ERROR,
    payload: { errors },
  }),
  deleteVirtualTokenStart: (data) => ({
    type: VirtualTokenMap.DELETE_VIRTUAL_TOKEN_START,
    payload: data,
  }),
  deleteVirtualTokenSuccess: (data) => ({
    type: VirtualTokenMap.DELETE_VIRTUAL_TOKEN_SUCCESS,
    payload: data,
  }),
  deleteVirtualTokenError: (errors) => ({
    type: VirtualTokenMap.DELETE_VIRTUAL_TOKEN_ERROR,
    payload: { errors },
  }),
  addVirtualTokenStart: (data) => ({
    type: VirtualTokenMap.ADD_VIRTUAL_TOKEN_START,
    payload: data,
  }),
  addVirtualTokenSuccess: (data) => ({
    type: VirtualTokenMap.ADD_VIRTUAL_TOKEN_SUCCESS,
    payload: data,
  }),
  addVirtualTokenError: (errors) => ({
    type: VirtualTokenMap.ADD_VIRTUAL_TOKEN_ERROR,
    payload: { errors },
  }),
  updateVirtualTokenStart: (data) => ({
    type: VirtualTokenMap.UPDATE_VIRTUAL_TOKEN_START,
    payload: data,
  }),
  updateVirtualTokenSuccess: (data) => ({
    type: VirtualTokenMap.UPDATE_VIRTUAL_TOKEN_SUCCESS,
    payload: data,
  }),
  updateVirtualTokenError: (errors) => ({
    type: VirtualTokenMap.UPDATE_VIRTUAL_TOKEN_ERROR,
    payload: { errors },
  }),
  getVirtualTokenTemplateStart: (data) => ({
    type: VirtualTokenMap.GET_ALL_TEMPLATES_START,
    payload: data,
  }),
  getVirtualTokenTemplateSuccess: (data) => ({
    type: VirtualTokenMap.GET_ALL_TEMPLATES_SUCCESS,
    payload: data,
  }),
  getVirtualTokenTemplateError: (errors) => ({
    type: VirtualTokenMap.GET_ALL_TEMPLATES_ERROR,
    payload: { errors },
  }),
  applyFilters: (data) => ({
    type: VirtualTokenMap.APPLY_FILTERS,
    payload: data,
  }),
  refreshVirtualTokenList: () => ({
    type: VirtualTokenMap.REFRESH_VIRTUAL_TOKEN_LIST,
  }),
  searchTextChange: (data) => ({
    type: VirtualTokenMap.SEARCH_TEXT_CHANGE,
    payload: data,
  }),
  setSelectedVirtualToken: (data) => ({
    type: VirtualTokenMap.SELECT_VIRTUAL_TOKEN_DETAILS,
    payload: data,
  }),
  setVirtualTokenBatchNumber: (data) => ({
    type: VirtualTokenMap.SET_VIRTUAL_TOKEN_BATCH_NUMBER,
    payload: data,
  }),
};
